var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-btn',[_vm._v("성공")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }